import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export const ScNetworkItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;
  background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  padding: 24px;
  align-items: center;

  & > .text {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.whiteColor};
  }

  & > img {
    width: 80px;
    height: 80px;
    transition: 0.3s;
  }

  @media (hover: hover) {
    &:hover {
      & > img {
        transform: scale(1.1);
      }
    }
  }

  @media (${device.mobileS}) {
    padding: 16px 24px;
    width: 100%;
    flex-direction: row;

    & > img {
      width: 64px;
      height: 64px;
    }
  }
`;
